module.exports = __webpack_public_path__ + "img/hermiones_note.9ceff20c.jpg";